import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on nav link click (mobile)
  const handleNavClick = (e, scrollHome = false) => {
    if (scrollHome) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <a href="/" onClick={e => handleNavClick(e, true)} className="navbar-logo">
          <img src="/images/logo.png" alt="Logo" className="logo-img" />
          <span className="logo-text">
            <span className="logo-title">7ima-SR.</span>
            <span className="logo-name">Ibrahim</span>
          </span>
        </a>
        <div className="nav-links">
          <a href="/" onClick={e => handleNavClick(e, true)} className="nav-link">Home</a>
          <a href="#about" onClick={handleNavClick} className="nav-link">About</a>
          <a href="#skills" onClick={handleNavClick} className="nav-link">Skills</a>
          <a href="#projects" onClick={handleNavClick} className="nav-link">Projects</a>
          <a href="#contact" onClick={handleNavClick} className="nav-link">Contact</a>
        </div>
        {/* Hamburger icon for mobile */}
        <button
          className={`navbar-hamburger${menuOpen ? ' open' : ''}`}
          aria-label="Toggle navigation menu"
          onClick={() => setMenuOpen(m => !m)}
        >
          <span className="bar bar1"></span>
          <span className="bar bar2"></span>
          <span className="bar bar3"></span>
        </button>
      </div>
      {/* Mobile menu overlay */}
      {menuOpen && (
        <div className="mobile-menu">
          <a href="/" onClick={e => handleNavClick(e, true)} className="nav-link">Home</a>
          <a href="#about" onClick={handleNavClick} className="nav-link">About</a>
          <a href="#skills" onClick={handleNavClick} className="nav-link">Skills</a>
          <a href="#projects" onClick={handleNavClick} className="nav-link">Projects</a>
          <a href="#contact" onClick={handleNavClick} className="nav-link">Contact</a>
        </div>
      )}
    </nav>
  );
};

export default Navbar; 